import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Multiselect from 'vue-multiselect';
import { rawDataDownload, daysBetween, MAX_DAYS } from '@/store/function/common/rawDataDownload';
import { isDateAfterToday } from '@/utils/datetime';


import { DateTime } from 'luxon';
import { mapState, mapActions } from 'vuex';
/** 下載項目的中文標籤。畫面給人看的是「高壓電表」，送給後端的仍是 'HV-meter' */
var ITEM_LABELS = {
  'HV-meter': '高壓電表',
  'LV-meter': '低壓電表',
  PVTemp: '模組溫度',
  ENVTemp: '環境溫度',
  Anemometer: '風速計'
};
var today = function today() {
  return DateTime.local().setZone('Asia/Taipei').toFormat('yyyy-MM-dd');
};

/** 快捷對應的 [開始, 結束]，一律以今天為結束 */
var presetRange = function presetRange(p) {
  var end = DateTime.local().setZone('Asia/Taipei');
  var start = end.minus({
    days: p.days - 1
  });
  return [start.toFormat('yyyy-MM-dd'), end.toFormat('yyyy-MM-dd')];
};
export default {
  name: 'RawDataDownload',
  components: {
    Multiselect: Multiselect
  },
  data: function data() {
    return {
      dateRange: [today(), today()],
      loadingData: false,
      selectedFactory: null,
      selected: [],
      maxDays: MAX_DAYS,
      datePresets: [{
        label: '今天',
        days: 1
      }, {
        label: '近 3 天',
        days: 3
      }, {
        label: '近 7 天',
        days: 7
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['factoryInfo'])), {}, {
    /** multiselect 用 { label, value }：畫面只顯示案場名，_fXXX 留在 value 給 API */factoryOptions: function factoryOptions() {
      return this.factoryInfo.filter(function (item) {
        return !item.isDemoSite;
      }).map(function (item) {
        return {
          label: item.factory,
          value: "".concat(item.factory, "_").concat(item.factoryId)
        };
      });
    },
    /**
     * 依所選案場列出可下載項目，分成電表／環境感測／變流器三組。
     * 分組不只是好看 —— 有的案場 62 台 INV，攤平成一排根本找不到要哪一台。
     */
    optionGroups: function optionGroups() {
      var _this = this,
        _info$irrPct,
        _info$invBrand$length,
        _info$invBrand,
        _info$invBrand2;
      // 用完整的 `名稱_fXXX` 比對，不要只比名稱 —— 同名案場會抓到錯的那個
      var info = this.factoryInfo.find(function (item) {
        var _this$selectedFactory;
        return "".concat(item.factory, "_").concat(item.factoryId) === ((_this$selectedFactory = _this.selectedFactory) === null || _this$selectedFactory === void 0 ? void 0 : _this$selectedFactory.value);
      });
      if (!info) return [];
      var label = function label(v) {
        var _ITEM_LABELS$v;
        return {
          text: (_ITEM_LABELS$v = ITEM_LABELS[v]) !== null && _ITEM_LABELS$v !== void 0 ? _ITEM_LABELS$v : v,
          value: v
        };
      };
      var irrList = (_info$irrPct = info.irrPct) !== null && _info$irrPct !== void 0 && _info$irrPct.length ? info.irrPct.map(function (_, i) {
        return {
          text: "\u65E5\u7167\u8A08 ".concat(i + 1),
          value: "IRR_".concat(i + 1)
        };
      }) : [{
        text: '日照計 1',
        value: 'IRR_1'
      }];
      return [{
        key: 'meter',
        title: '電表',
        items: ['HV-meter', 'LV-meter'].map(label)
      }, {
        key: 'env',
        title: '環境感測',
        items: [].concat(_toConsumableArray(irrList), _toConsumableArray(['PVTemp', 'ENVTemp', 'Anemometer'].map(label)))
      }, {
        key: 'inv',
        title: "\u8B8A\u6D41\u5668\uFF08".concat((_info$invBrand$length = (_info$invBrand = info.invBrand) === null || _info$invBrand === void 0 ? void 0 : _info$invBrand.length) !== null && _info$invBrand$length !== void 0 ? _info$invBrand$length : 0, " \u53F0\uFF09"),
        items: ((_info$invBrand2 = info.invBrand) !== null && _info$invBrand2 !== void 0 ? _info$invBrand2 : []).map(function (_, i) {
          return {
            text: "INV ".concat(i + 1),
            value: "INV_".concat(i + 1)
          };
        })
      }].filter(function (g) {
        return g.items.length;
      });
    },
    allOptionValues: function allOptionValues() {
      return this.optionGroups.flatMap(function (g) {
        return g.items.map(function (i) {
          return i.value;
        });
      });
    },
    /** 現在的區間剛好等於哪個快捷。算出來的，不另外存狀態 —— 手動改日期它自然就不亮了 */activePreset: function activePreset() {
      var _this$dateRange, _hit$label;
      var _ref = (_this$dateRange = this.dateRange) !== null && _this$dateRange !== void 0 ? _this$dateRange : [],
        _ref2 = _slicedToArray(_ref, 2),
        from = _ref2[0],
        to = _ref2[1];
      var hit = this.datePresets.find(function (p) {
        var _presetRange = presetRange(p),
          _presetRange2 = _slicedToArray(_presetRange, 2),
          pf = _presetRange2[0],
          pt = _presetRange2[1];
        return pf === from && pt === to;
      });
      return (_hit$label = hit === null || hit === void 0 ? void 0 : hit.label) !== null && _hit$label !== void 0 ? _hit$label : '';
    },
    days: function days() {
      var _this$dateRange2;
      var _ref3 = (_this$dateRange2 = this.dateRange) !== null && _this$dateRange2 !== void 0 ? _this$dateRange2 : [],
        _ref4 = _slicedToArray(_ref3, 2),
        from = _ref4[0],
        to = _ref4[1];
      return from && to ? daysBetween(from, to) : 0;
    },
    canDownload: function canDownload() {
      return Boolean(this.selectedFactory && this.days >= 1 && this.days <= this.maxDays && this.selected.length && !this.loadingData);
    }
  }),
  watch: {
    // 換案場就把勾選清掉 —— INV_5 在另一個案場可能根本不存在
    selectedFactory: function selectedFactory() {
      this.selected = [];
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions(['asyncInfo'])), {}, {
    isDateAfterToday: isDateAfterToday,
    applyPreset: function applyPreset(p) {
      this.dateRange = presetRange(p);
    },
    setAll: function setAll(on) {
      this.selected = on ? _toConsumableArray(this.allOptionValues) : [];
    },
    isGroupAllSelected: function isGroupAllSelected(group) {
      var _this2 = this;
      return group.items.every(function (i) {
        return _this2.selected.includes(i.value);
      });
    },
    toggleGroup: function toggleGroup(group) {
      var values = group.items.map(function (i) {
        return i.value;
      });
      this.selected = this.isGroupAllSelected(group) ? this.selected.filter(function (v) {
        return !values.includes(v);
      }) : _toConsumableArray(new Set([].concat(_toConsumableArray(this.selected), _toConsumableArray(values))));
    },
    download: function download() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this3$dateRange, from, to, _yield$rawDataDownloa, ok, message;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this3.canDownload) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                // 資料量的上限在後端（伺服器記憶體），超過會回訊息。見 ADR-0007
                _this3.loadingData = true;
                _this3$dateRange = _slicedToArray(_this3.dateRange, 2), from = _this3$dateRange[0], to = _this3$dateRange[1];
                _context.next = 6;
                return rawDataDownload(_this3.selectedFactory.value, from, to, _this3.selected);
              case 6:
                _yield$rawDataDownloa = _context.sent;
                ok = _yield$rawDataDownloa.ok;
                message = _yield$rawDataDownloa.message;
                if (!ok) {
                  _this3.$swal(message || '所選項目尚無資料');
                }
                _this3.loadingData = false;
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }),
  mounted: function mounted() {
    var _this4 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this4.factoryInfo.length) {
                _context2.next = 3;
                break;
              }
              _context2.next = 3;
              return _this4.asyncInfo();
            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};